export const GET_COMMENTS = 'GET_COMMENTS'
export const SET_COMMENTS = 'SET_COMMENTS'
export const SET_COMMENTS_OFFSET_LIMIT = 'SET_COMMENTS_OFFSET_LIMIT'
export const SET_COMMENTS_DATA_ITEM_STATUS = 'SET_COMMENTS_DATA_ITEM_STATUS'
export const SET_COMMENTS_DATA_ITEM_PUBLIHSING = 'SET_COMMENTS_DATA_ITEM_PUBLIHSING'
export const DELETE_COMMENTS_DATA_ITEM_PUBLIHSING = 'DELETE_COMMENTS_DATA_ITEM_PUBLIHSING'

export function getComments ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: GET_COMMENTS,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}

export function setComments ({
  storeKey, data, total, processing = false,
}) {
  return {
    type: SET_COMMENTS,
    payload: {
      storeKey, data, total, processing,
    },
  }
}

export function setCommentsOffsetLimit ({
  storeKey, offset, limit, processing = true,
}) {
  return {
    type: SET_COMMENTS_OFFSET_LIMIT,
    payload: {
      storeKey, offset, limit, processing,
    },
  }
}

/**
 * Set the status for an individual comment in the data list
 */
export function setCommentsDataItemStatus ({ storeKey, item, status }) {
  return {
    type: SET_COMMENTS_DATA_ITEM_STATUS,
    payload: { storeKey, item, status },
  }
}

/**
 * Set the publishing value for an individual comment in the data list
 */
export function setCommentsDataItemPublishing ({ storeKey, item, publishing }) {
  return {
    type: SET_COMMENTS_DATA_ITEM_PUBLIHSING,
    payload: { storeKey, item, publishing },
  }
}

/**
 * Set the unpublishing value for an individual comment in the data list
 */
export function deleteCommentsDataItemPublishing ({ storeKey, item }) {
  return {
    type: DELETE_COMMENTS_DATA_ITEM_PUBLIHSING,
    payload: { storeKey, item },
  }
}
